<template lang="html">
  <v-dialog v-model="dialogNote" scrollable style="width: 96vw; margin: 10px !important;">
    <v-card>
      <v-toolbar card style="background: #2562af !important;">
        <v-toolbar-title class="white--text CSChatThai">&nbsp;&nbsp;โน๊ต</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn dark icon flat @click.native="edit_note" v-if="checkUser == 'owner'">
          <v-icon style="color: white !important; font-size: 20px !important;">fas fa-edit</v-icon>
        </v-btn>
        <v-btn dark icon flat @click.native="remove_note" v-if="checkUser == 'owner'">
          <v-icon style="color: white !important; font-size: 20px !important;">far fa-trash-alt</v-icon>
        </v-btn>

        <v-btn dark icon flat @click.native="save_note" v-if="checkUser == 'editstate'">
          <v-icon style="color: white !important; font-size: 20px !important;">far fa-save</v-icon>
        </v-btn>

        <v-btn dark icon flat @click.native="closeDialog" v-if="checkUser != 'editstate'">
          <v-icon style="color: white !important; font-size: 20px !important;">clear</v-icon>
        </v-btn>
        <v-btn dark icon flat @click.native="cancel_note" v-else>
          <v-icon style="color: white !important; font-size: 20px !important;">clear</v-icon> 
        </v-btn>

        


      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text style="height: 550px;     padding: 10px !important;" v-if="checkUser != 'undefined' && checkUser != 'editstate'">
        <v-layout row wrap style="text-align: center;">
           <v-layout row wrap >
      <v-flex xs2 xl2 lg2 md2 sm2 style="padding: 15px 0px;display: flex;
    justify-content: center;">
        <v-avatar size="35" class="profileBG" >
    <img :src="backend + note_detail.user_created.profile_picture" class="alligator-turtle" v-if="note_detail.user_created.profile_picture" />
      <span class="headline" v-else>{{note_detail.user_created.display_name.charAt(0)}}</span>
  </v-avatar>
      </v-flex>
       <v-flex xs10 xl10 lg10 md10 sm10 style="padding: 10px 10px 2px  0px;     text-align: left;">
        <span style="color: #2562af !important;font-weight: 600; white-space: nowrap;width: 15em; overflow: hidden; text-overflow: ellipsis;">{{note_detail.user_created.display_name}}</span>

 <div v-html="convert(note_detail.note_data.text).replace(/(?:\r\n|\r|\n)/g, '<br>')" style="width: 90%;;
    white-space: break-spaces;overflow: hidden;"></div>
        <p style="font-size: 9px;color: #1010106b; margin-top: 10px; margin-bottom: 0 !important;">สร้างเมื่อ {{dateMoment(note_detail.create_at)}} - {{timeMoment(note_detail.create_at)}}</p>
        <p style="font-size: 9px;color: #1010106b;margin-bottom: 0 !important;" v-if="note_detail.last_update">แก้ไขล่าสุดเมื่อ {{dateMoment(note_detail.last_update)}} - {{timeMoment(note_detail.last_update)}}</p>
      </v-flex>
      <v-flex xs12 xl12 lg12 md12 sm12 >
      <v-divider></v-divider>
    </v-flex>
    </v-layout>
    </v-layout>
      </v-card-text>



      <v-card-text style="height: 550px;     padding: 10px !important;" v-else-if="checkUser == 'editstate'">
        <v-layout row wrap style="text-align: center;">
           <v-layout row wrap >
      
       <v-flex xs12 xl12 lg12 md12 sm12 style="padding: 10px 10px 2px  0px;     text-align: left;">

        <v-textarea
            outlined
            name="input-7-4"
            rows="23"
            placeholder="แชร์โน๊ตในห้องสนทนา"
            value="The Woodman set to work at once, and so sharp was his axe that the tree was soon chopped nearly through."
            v-model="note_data"
          ></v-textarea>


      </v-flex>
      <v-flex xs12 xl12 lg12 md12 sm12 >
      <v-divider></v-divider>
    </v-flex>
    </v-layout>
    </v-layout>
      </v-card-text>





      <v-card-text style="height: 550px;     padding: 10px !important;    text-align: center;" v-else>
        ไม่พบโน๊ตที่คุณเปิด
      </v-card-text>
      <!-- <v-divider></v-divider> -->
    </v-card>
  </v-dialog>
</template>

<script>
import gql from 'graphql-tag'
import { Momenttime, Decode, Encode } from '@/services'
const noteDetail = gql`
query MyQuery($note_id: uuid) {
  notes(where: {note_id: {_eq: $note_id}, status_show: {_eq: true}}) {
    user_created {
      display_name
      profile_picture
      user_id
    }
    create_at
    create_by
    last_update
    note_data
    note_id
    room_id
    status_show
  }
}
`
const noteRemove = gql`
mutation ($note_id: uuid, $room_id: uuid, $user_remove: uuid) {
  update_notes(where: {note_id: {_eq: $note_id}, room_id: {_eq: $room_id}, create_by: {_eq: $user_remove}}, _set: {status_show: false}) {
    returning {
      create_at
      create_by
      last_update
      note_data
      note_id
      room_id
      status_show
      user_created {
        display_name
        email
        profile_picture
        user_id
      }
    }
  }
}
`

const noteEdit = gql`
mutation ($note_data: jsonb, $room_id: uuid, $note_id: uuid, $create_by: uuid) {
  update_notes(where: {room_id: {_eq: $room_id},note_id: {_eq: $note_id},create_by: {_eq: $create_by}}, _set: {note_data: $note_data, last_update:"now()"}) {
    returning {
      room_id
      note_id
      note_data
      create_by
      last_update
    }
  }
}
`

export default {
  props: {
    dialogNote: Boolean,
    note_id: String
  },
  data () {
    return {
      note_data: '',
      note_data_old: '',
      note_detail: {},
      user_id: '',
      room_id: '',
      checkUser: 'undefined',
      backend: process.env.VUE_APP_API
    }
  },
  watch: {
    dialogNote () {
      if (this.dialogNote) {
        // console.log('this.note_id')
        this.note_data= ''
        this.note_detail = {}
        this.$apollo.query({
          query: noteDetail,
          variables: {
            note_id: this.note_id
          },
          fetchPolicy: 'no-cache'
        }).then((response) => {
          // console.log(response)

          // this.note_detail = response.data.notes[0]
          if (response.data.notes.length > 0) {
            this.note_detail = response.data.notes[0]
            this.note_data = this.note_detail.note_data.text
            this.note_data_old = this.note_detail.note_data.text
            this.checkUser = (this.note_detail.user_created.user_id == this.user_id)? 'owner':'other'
          } else {
            // console.log(response.data.notes)
            // this.note_detail['user_created']['user_id'] = 'undefined'
            this.checkUser = 'undefined'
          }


        })
      }
    }
  },
  created() {
    this.room_id = this.$route.query.id
    this.user_id = Decode.decodeToken(localStorage.getItem('user_id'))
  },
  methods: {
    cancel_note () {
      this.note_data = this.note_data_old
      this.checkUser = (this.note_detail.user_created.user_id == this.user_id)? 'owner':'other'
    },
    save_note () {
      this.$swal({
        text: 'คุณต้องการบันทึกโน๊ตใช่หรือไม่?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#2562af',
        cancelButtonColor: '#9f9f9f',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่ใช่',
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.$apollo.mutate({
            mutation: noteEdit,
            variables: {
              note_data: {
                text: this.note_data,
                note_id: this.note_detail.note_id
              },
              room_id: this.room_id,
              note_id: this.note_detail.note_id,
              create_by: this.user_id
            }
          }).then(data => {
            // console.log(data.data.update_notes.returning[0].last_update)
            this.changeNote()
            this.note_detail.last_update = data.data.update_notes.returning[0].last_update
            this.note_detail.note_data.text = data.data.update_notes.returning[0].note_data.text
            this.note_data_old = this.note_data
            this.checkUser = (this.note_detail.user_created.user_id == this.user_id)? 'owner':'other'
            // this.closeDialog()
            this.$swal(
              'แก้ไขโน๊ตสำเร็จแล้ว',
              '',
              'success')
          })
        } else {
          this.cancel_note()
        }
      })
    },
    edit_note () {
      this.checkUser = 'editstate'
      // console.log('edit')
    },
    remove_note () {
      // console.log('remove')
      // console.log({room_id: this.room_id, note_id: this.note_detail.note_id, user_remove: this.user_id})
      this.$swal({
        text: 'คุณต้องการลบโน๊ตใช่หรือไม่?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#2562af',
        cancelButtonColor: '#9f9f9f',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่ใช่',
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.$apollo.mutate({
            mutation: noteRemove,
            variables: {
              room_id: this.room_id,
              note_id: this.note_detail.note_id,
              user_remove: this.user_id
            }
          }).then(data => {
            this.changeNote()
            this.closeDialog()
            this.$swal(
              'ลบโน๊ตสำเร็จแล้ว',
              '',
              'success')
          })
        }
      })
      
    },
    convert(msg) {
      var linkifyStr = require('linkifyjs/string')
      var str = msg
      var processedContent = linkifyStr(str)
      return processedContent
    },
    timeMoment(data) {
      return Momenttime.momenttimethai(data) //+ ' น.'
    },
    dateMoment(data) {
      return Momenttime.momentdatethai(data)
    },
    changeNote () {
      this.$emit('changeNote', true)
    },
    closeDialog () {
      this.$emit('closeNote', false)
      this.checkUser = 'undefined'
    }
  }
}
</script>

<style lang="css" scoped>
>>>.v-dialog {
  margin: 10px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/mail/Detail/NoteDialog.vue